import React from "react";
import Fallback from "../../components/Fallback";

const CreateTemplateMessage = React.lazy(
  () => import("../template/CreateTemplateMessage")
);

const TemplateMessage = React.lazy(() => import("../template/TemplateMessage"));

export const CreateTemplateMessageScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <CreateTemplateMessage {...props} />
  </React.Suspense>
);

export const TemplateMessageScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <TemplateMessage {...props} />
  </React.Suspense>
);
